// SignOut.js
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "auth-context/auth.context";
import AuthApi from "api/auth";

function SignOut() {
  const history = useHistory();
  const { logout } = useAuth(); // Usar la función logout del AuthContext

  const handleLogout = async () => {
    try {
      // Primero usar el método de AuthApi
      await AuthApi.Logout();
      // Luego usar el logout del contexto que limpia estados
      await logout();
      // Finalmente redirigir
      history.push("/authentication/sign-in");
    } catch (error) {
      console.error("Error durante el logout:", error);
      // Aún así intentar redirigir al login
      history.push("/authentication/sign-in");
    }
  };

  useEffect(() => {
    handleLogout();
  }, []);

  return null;
}

export default SignOut;
